/** Block in page_json_v1.content.blocks */
export interface ContentBlock {
  type: string;
  text?: string;
  [key: string]: unknown;
}

/** Asset in page_json_v1.assets */
export interface PageAsset {
  id?: string;
  kind?: string;
  url?: string;
  asset_id?: string;
  [key: string]: unknown;
}

/** MCQ option */
export interface McqOption {
  id: string;
  text?: string;
  image_asset_id?: string;
  number?: number;
  [key: string]: unknown;
}

/** MCQ interaction */
export interface McqInteraction {
  id: string;
  type: 'mcq';
  prompt?: string;
  options: McqOption[];
  answer_option_id: string;
  shuffle?: boolean;
}

/** Fill-blanks segment (text or blank) */
export interface FillBlankSegment {
  text?: string;
  blank?: boolean;
  blank_id?: string;
  choices?: string[];
  answer?: string;
}

/** Fill blanks interaction */
export interface FillBlanksInteraction {
  id: string;
  type: 'fill_blanks';
  prompt?: string;
  segments: FillBlankSegment[];
}

/** Speak repeat interaction */
export interface SpeakRepeatInteraction {
  id: string;
  type: 'speak_repeat';
  prompt?: string;
  target_text?: string;
  audio_asset_id?: string;
}

/** Union of interaction types */
export type Interaction =
  | McqInteraction
  | FillBlanksInteraction
  | SpeakRepeatInteraction
  | { id: string; type: string; [key: string]: unknown };

/** Type guards */
export function isMcqInteraction(i: Interaction): i is McqInteraction {
  return i.type === 'mcq';
}
export function isFillBlanksInteraction(i: Interaction): i is FillBlanksInteraction {
  return i.type === 'fill_blanks';
}
export function isSpeakRepeatInteraction(i: Interaction): i is SpeakRepeatInteraction {
  return i.type === 'speak_repeat';
}

/** page_json_v1 structure */
export interface PageJsonV1 {
  content?: {
    blocks?: ContentBlock[];
    [key: string]: unknown;
  };
  assets?: PageAsset[];
  skill_tags?: string[];
  interactions?: Interaction[];
  completion_only?: boolean;
  [key: string]: unknown;
}
